import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppStatsIntroPage } from './app-stats-intro';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppStatsIntroPage,
  ],
  imports: [
    IonicPageModule.forChild(AppStatsIntroPage),
    PipesModule,
    DirectivesModule,
  ],
})
export class AppStatsIntroPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-stats-intro/app-stats-intro.module.ts